import styles from "../../styles/components/searchFigma/SearchEmpty.module.css";
import styles2 from "../../styles/components/searchFigma/ResultListItem.module.css";

export default function SearchEmpty({ keyword, isLogin }) {
  const handleQuoteRequest = () => {
    const baseUrl = `/estimate/quote_request?it_name=${keyword}`;
    const loginUrl = `/auth/login?before=${baseUrl}`;
    window.location.href = isLogin === "0" ? loginUrl : baseUrl;
  };

  return (
    <div className={styles.frame02}>
      <div className={styles.frame020}>
        <div className={styles.notfound}>
          {/* ✅ background 대신 실제 이미지 태그 사용 */}
          <img
            src="/images/search/notfound.png"
            alt="검색 결과 없음"
            className={styles.notfoundImage}
          />
        </div>
      </div>
      <div className={styles.frame021}>
        <div className={`${styles.noContent} title1`}>검색 결과가 없어요!</div>
        <div className={`${styles.summary} body2`}>
          다른 키워드로 검색해보거나 <br />
          단어 또는 부품 번호가 정확한지 확인해주세요.
        </div>
      </div>
      {/* ✅ 푸터 위에 뜨는 견적 요청 카드 */}
      <div className={styles.floatingCard} onClick={handleQuoteRequest}>
        <div className={styles.textWrapper}>
          <div className={styles.cardTitleWrapper}>
            <span className={`${styles.cardTitle} body1`}>‘{keyword}’</span>
            <span className={`${styles.cardDesc} body1`}>이 필요하신가요?</span>
          </div>
          <div className={`${styles.cardDesc} body4`}>
            판다파츠에 견적을 요청해보세요.
            <br />
            최대 12시간 이내에 빠르게 안내드릴게요.
          </div>
        </div>
        <div className={styles.buttonCenter}>
          <div className={styles.buttonGroup}>
            <div className={styles2.requestButton}>
              <div className={styles2.iconLightning}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className={`${styles2.bodyiconLigthing} body1`}>
                견적바로받기
              </div>
            </div>
            <div className={styles2.iconChevronRight}>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
